import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  plans: [],
  selectedPlan: null,
};

const plansSlice = createSlice({
  name: "plans",
  initialState,
  reducers: {
    // Get Plans
    getPlansStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getPlansSuccess: (state, action) => {
      state.loading = false;
      state.plans = action.payload;
      state.error = null;
    },
    getPlansFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Create Plan
    createPlanStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createPlanSuccess: (state, action) => {
      state.loading = false;
      state.plans.push(action.payload);
      state.error = null;
    },
    createPlanFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update Plan
    updatePlanStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updatePlanSuccess: (state, action) => {
      state.loading = false;
      const index = state.plans.findIndex(plan => plan.id === action.payload.id);
      if (index !== -1) {
        state.plans[index] = action.payload;
      }
      state.error = null;
    },
    updatePlanFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },


    // Set Selected Plan
    setSelectedPlan: (state, action) => {
      state.selectedPlan = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getPlansStart,
  getPlansSuccess,
  getPlansFailure,
  createPlanStart,
  createPlanSuccess,
  createPlanFailure,
  updatePlanStart,
  updatePlanSuccess,
  updatePlanFailure,
  setSelectedPlan,
  clearError,
} = plansSlice.actions;

export default plansSlice.reducer;